import { List, Text } from "@clipboard-health/ui-components";
import { DeprecatedGlobalAppV1Paths } from "@src/appV2/App/paths";
import { useEmbeddedMode } from "@src/appV2/EmbeddedMode/EmbeddedModeContext";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";
import { PROFILE_FULL_PATH } from "@src/appV2/redesign/Accounts/paths";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useHistory } from "react-router-dom";

import { CLIPBOARD_SCORE_FULL_PATH } from "../../ClipboardScore/utils/paths";
import { isWorkerInviteRequired } from "../../ClipboardScore/utils/utils";
import { NOTIFICATIONS_PREFERENCE_PATH_FULL } from "../../NotificationPreferences/paths";
import { WORK_WITH_FRIENDS_FULL_PATH } from "../../ShiftDiscovery/paths";
import { AccountListItem } from "../components/AccountListItem";
import { PAYOUT_SETTINGS_FULL_PATH } from "../PayoutSettings/paths";
import { ACCOUNT_ROLES_FULL_PATH } from "../Roles/paths";
import { logAccountPageMenuItemTapped } from "../utils";

export function AccountsPageSettingsSection() {
  const worker = useDefinedWorker();
  const history = useHistory();
  const { isEmbedded } = useEmbeddedMode();

  const licenseReciprocityEnabled = useCbhFlag(CbhFeatureFlag.LICENSE_RECIPROCITY, {
    defaultValue: false,
  });
  const isPayoutSettingsEnabled = useCbhFlag(CbhFeatureFlag.ENABLE_NEW_PAYOUT_SETTINGS, {
    defaultValue: false,
  });

  const manageLicensesTitleText = "Manage Roles & Licenses";

  const isInviteRequired = isWorkerInviteRequired(worker);

  const showClipboardScorePage = !isInviteRequired;

  return (
    <List>
      <AccountListItem
        primaryText="Personal Information"
        iconType="user"
        onClick={() => {
          logAccountPageMenuItemTapped("Profile");
          history.push(PROFILE_FULL_PATH);
        }}
      />

      {showClipboardScorePage && (
        <AccountListItem
          primaryText="Clipboard Score"
          iconType="trending-up"
          onClick={() => {
            logAccountPageMenuItemTapped("Clipboard Score");
            history.push(CLIPBOARD_SCORE_FULL_PATH);
          }}
        />
      )}

      <AccountListItem
        primaryText={manageLicensesTitleText}
        iconType="document"
        onClick={() => {
          logAccountPageMenuItemTapped(manageLicensesTitleText);
          history.push(ACCOUNT_ROLES_FULL_PATH);
        }}
      />
      {licenseReciprocityEnabled && (
        <AccountListItem
          primaryText="Get Licensed in Another State"
          secondaryText={
            <Text variant="caption" color={(theme) => theme.palette.text.secondary}>
              Apply for licenses in other states through reciprocity
            </Text>
          }
          iconType="document-search"
          onClick={() => {
            logAccountPageMenuItemTapped("Get Licensed in Another State");
            history.push(DeprecatedGlobalAppV1Paths.LICENSE_RECIPROCITY);
          }}
        />
      )}

      {!isEmbedded && (
        <AccountListItem
          primaryText="Earnings"
          iconType="coin"
          onClick={() => {
            logAccountPageMenuItemTapped("Earnings");
            history.push(DeprecatedGlobalAppV1Paths.PAYROLL);
          }}
        />
      )}
      {!isEmbedded && isPayoutSettingsEnabled && (
        <AccountListItem
          primaryText="Payout Settings"
          iconType="bank"
          onClick={() => {
            logAccountPageMenuItemTapped("Payout Settings");
            history.push(PAYOUT_SETTINGS_FULL_PATH);
          }}
        />
      )}

      {!isEmbedded && (
        <AccountListItem
          primaryText="Notifications"
          iconType="bell-outlined"
          onClick={() => {
            logAccountPageMenuItemTapped("Notification Preferences");
            history.push(NOTIFICATIONS_PREFERENCE_PATH_FULL);
          }}
        />
      )}
      {!isEmbedded && (
        <AccountListItem
          fullWidthDivider
          primaryText="Work with Friends"
          iconType="user-group"
          onClick={() => {
            logAccountPageMenuItemTapped("Work with Friends");
            history.push(WORK_WITH_FRIENDS_FULL_PATH);
          }}
        />
      )}
    </List>
  );
}
